import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects'
import { push } from 'react-router-redux';
import { actionTypes } from '../constants';
import fetch from '../utils/fetch';
import awsconfig from '../awsconfig';
import history from '../history';

const excludedFields = [
  '_id',
  'objectType',
  'createdAt',
  'updatedAt',
  'vcaInsurerId',
  'vcaApiError',
  'users'
];

var Api = {
    fetchDepartments: async () => {
        console.log('fetchDepartments begin')
        let response = await fetch({
            url: `${awsconfig.officeApi}/clients`,
            method: 'get',
        })
        return response.result;
    },
    fetchDepartment: async (id) => {
        console.log('fetchDepartment begin')
        let response = await fetch({
            url: `${awsconfig.officeApi}/clients/${id}`,
            method: 'get',
        })
        return response.result;
    },
    updateDepartment: async (id, data) => {
        console.log('updateDepartment begin')
        // create a copy before deleting excluded keys
        const clone = JSON.parse(JSON.stringify(data));
        // remove keys that API will not accept
        Object.keys(clone).map(key => {
          if (excludedFields.includes(key)) {
            delete clone[key];
          }
        });
        let response = await fetch({
            url: `${awsconfig.officeApi}/clients/${id}`,
            data: clone,
            method: 'put',
        })
        return response.result;
    },
    createDepartment: async (data) => {
        console.log('createDepartment begin')
        // create a copy before deleting excluded keys
        const clone = JSON.parse(JSON.stringify(data));
        // remove keys that API will not accept
        Object.keys(clone).map(key => {
          if (excludedFields.includes(key)) {
            delete clone[key];
          }
        });
        let response = await fetch({
            url: `${awsconfig.officeApi}/clients`,
            data: clone,
            method: 'post',
        })
        return response.result;
    },
}

function* fetchDepartments(action) {
    try {
        yield put({type: actionTypes.SPINNING_START})
        const departments = yield call(Api.fetchDepartments);
        yield put({type: actionTypes.DEPARTMENTS_FETCH_ALL_SUCCESS, departments: departments});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'success',
            text: `Loaded ${departments.length} departments from the server.`
          }
        });
    } catch (e) {
        yield put({type: actionTypes.DEPARTMENTS_FETCH_ALL_ERROR, error: e.message});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'error',
            text: e.message
          }
        });
    } finally {
        yield put({type: actionTypes.SPINNING_STOP})
    }
}

function* fetchDepartment(action) {
    try {
        yield put({type: actionTypes.SPINNING_START})
        const department = yield call(Api.fetchDepartment, action.id);
        yield put({type: actionTypes.DEPARTMENTS_FETCH_ONE_SUCCESS, detail: department});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'success',
            text: `Loaded 1 department from the server.`
          }
        });
    } catch (e) {
        yield put({type: actionTypes.DEPARTMENTS_FETCH_ONE_ERROR, error: e.message});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'error',
            text: e.message
          }
        });
    } finally {
        yield put({type: actionTypes.SPINNING_STOP})
    }
}

function* updateDepartment(action) {
    try {
        yield put({type: actionTypes.SPINNING_START})
        const department = yield call(Api.updateDepartment, action.id, action.data);
        yield put({type: actionTypes.DEPARTMENTS_UPDATE_ONE_SUCCESS, detail: action.data});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'success',
            text: `Updated 1 department.`
          }
        });
    } catch (e) {
        console.error(e)
        yield put({type: actionTypes.DEPARTMENTS_UPDATE_ONE_ERROR, error: e.message});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'error',
            text: e.message
          }
        });
    } finally {
        yield put({type: actionTypes.SPINNING_STOP})
    }
}

function* createDepartment(action) {
    try {
        yield put({type: actionTypes.SPINNING_START})
        const createdDepartments = yield call(Api.createDepartment, action.data); // returns array
        yield put({type: actionTypes.DEPARTMENTS_CREATE_ONE_SUCCESS, detail: action.data});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'success',
            text: `Created 1 department.`
          }
        });
        const department = createdDepartments[0];
        // redirect to department detail page
        history.push(`/app/departments/${department._id}`);
    } catch (e) {
        console.error(e)
        yield put({type: actionTypes.DEPARTMENTS_CREATE_ONE_ERROR, error: e.message});
        yield put({
          type: actionTypes.SNACKBAR,
          snackbar: {
            severity: 'error',
            text: e.message
          }
        });
    } finally {
        yield put({type: actionTypes.SPINNING_STOP})
    }
}

// throttle (e.g. for autocomplete search)
// takeEvery
// takeLatest
export const sagas = {
    fetchDepartmentsSaga: takeLatest(actionTypes.DEPARTMENTS_FETCH_ALL, fetchDepartments),
    fetchDepartmentSaga: takeLatest(actionTypes.DEPARTMENTS_FETCH_ONE, fetchDepartment),
    updateDepartmentSaga: takeLatest(actionTypes.DEPARTMENTS_UPDATE_ONE, updateDepartment),
    createDepartmentSaga: takeLatest(actionTypes.DEPARTMENTS_CREATE_ONE, createDepartment),
}
